import React from 'react';
import { Card } from 'react-bootstrap';
import './Error.css';

function createErrorBox (message) {
    return (
            <Card className="shadow mt-5 mx-auto mb-xt card-width-800">
                <Card.Body>
                    <h1 className="text-center mt-4 mb-3 mx-auto font-weight-bold text-scb error-code">Sorry</h1>
                    <h2 className="text-center mx-auto font-weight-bold text-scb">{message}</h2>         
                    <p className="text-center mx-auto text-secondary mt-5 mb-5">For more information, Please contact SCB Business Call Center +662 7222 222.</p>                
                </Card.Body>
            </Card> 
    );

}

function NotFound() {
    const errorMessage = createErrorBox (
        "We couldn't find the page you're looking for."
    );
    return errorMessage;            
}

function Unauthorized() {
    const errorMessage = createErrorBox (
        "You don't have permission to access this page."
    );
    return errorMessage;      
}

export { Unauthorized, NotFound };